import React  from 'react';
import './App.css';
import './SelectLocation.css';

import { useNavigate } from "react-router-dom";

class SelectLocation extends React.Component {

	async serverSetUserSettingsData(userID, userFullName, locationID) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/setusersettingsdata?userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		url = url + "&locationid=" + locationID;
		
		try {
			var res = await fetch(url);
			await res.text();
		} catch (err) {
		}
	}
	
	handleSelectLocation(locationID) {
		this.serverSetUserSettingsData(this.props.userID, this.props.fullName, locationID);
		this.props.setSelectedLocation(locationID);
		const navigate = this.props.navigate;
  		navigate("/courts");
	}

	renderOneLocation(itemObj) {

		var locationID = itemObj.locationID;
		var locationName = itemObj.locationName;
		var ipAddress = itemObj.ipAddress;

		if (ipAddress === null) {
			ipAddress = "";
		}
		
		var displayString = locationName;
		if (ipAddress !== "") {
			displayString = locationName + " - " + ipAddress;
		}

		return (
			<div key={locationID} className="SelectLocationTextContainer">
				<div className="SelectLocationText" onClick={() => this.handleSelectLocation(locationID)}>
					{displayString}
				</div>
			</div>
		);
	}

	renderAllLocations() {

		var locationListJsonObj = this.props.locationListJsonObj;
		if (locationListJsonObj === null) {
			return;
		}

		var length = locationListJsonObj.length;
		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<length; i++) {
			itemObj = locationListJsonObj[i];
			jsxCode = this.renderOneLocation(itemObj);
			jsxArray.push(jsxCode);
		}
		
		return jsxArray;
	}

	render() {
		return (
			<div className="SelectLocationTopContainer">
				<div style={{height: "20px"}}></div>
				{this.renderAllLocations()}
			</div>
		);
	}
}

export default function SelectLocationFunction(props) {
	const navigate = useNavigate();
	return <SelectLocation {...props} navigate={navigate} />;
}

